/**
 * Skeleton (workflows) — thin adapter over the shared primitive
 * (~/common/components/Skeleton). Kept at this path with the same default
 * export + SkeletonProps so existing workflow consumers (ClientContextTile,
 * PinnedHeader, etc.) are untouched. The Outlook add-in keeps its own mirrored
 * copy (ui/CLAUDE.md rule #1 — mirror-by-copy, no cross-import).
 *
 * Pins the `block` variant with rounded="rounded" + ariaLabel default "Loading"
 * so the emitted classes + a11y match the original implementation.
 */
import SharedSkeleton from "~/common/components/Skeleton";

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  ariaLabel?: string;
}

export default function Skeleton({
  width,
  height,
  className,
  ariaLabel = "Loading",
}: SkeletonProps) {
  return (
    <SharedSkeleton
      variant="block"
      rounded="rounded"
      width={width}
      height={height}
      className={className}
      ariaLabel={ariaLabel}
    />
  );
}
